import axios from 'axios';

// Cadastro de consulta de veículos (/veiculos): guarda placa, chassi, RENAVAM, motor, ano fabricação/modelo, marca/modelo e cor
// para preencher requerimentos e declarações depois. Não é usado por OS nem por NFS-e.
// Nunca lança: o preenchimento automático não pode bloquear o preenchimento manual.

const authHeader = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('jwtToken')}` } });

// Busca pela placa (ou, sem placa, pelo chassi). Devolve o veículo gravado ou null.
export async function buscarVeiculo(apiBaseUrl, { placa, chassi }) {
  const params = new URLSearchParams();
  const p = (placa || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  const c = (chassi || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (p) params.set('placa', p);
  if (c) params.set('chassi', c);
  if (!p && !c) return null;
  try {
    const res = await axios.get(`${apiBaseUrl}/veiculos/busca?${params.toString()}`, authHeader());
    return res.status === 200 && res.data ? res.data : null;
  } catch (error) {
    console.error('Erro ao buscar veículo:', error);
    return null;
  }
}

// Cria ou atualiza o veículo. Campos vazios não apagam o que já está gravado. Devolve true se gravou.
export async function salvarVeiculo(apiBaseUrl, { placa, chassi, renavam, motor, anoFabricacaoModelo, marcaModelo, cor }) {
  const p = (placa || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  const c = (chassi || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (!p && !c) return false;
  try {
    await axios.post(`${apiBaseUrl}/veiculos`, {
      placa: p || null,
      chassi: c || null,
      renavam: renavam || null,
      motor: motor || null,
      anoFabricacaoModelo: anoFabricacaoModelo || null,
      marcaModelo: marcaModelo || null,
      cor: cor || null,
    }, authHeader());
    return true;
  } catch (error) {
    console.error('Erro ao gravar veículo:', error);
    return false;
  }
}
